// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Review & confirm page.
   Depends on dashboard-redesign.css (.rf-app, .rf-btn, .rf-link, .rf-serif,
   .rf-num, .rf-spacer, .rf-segmented, .rf-label) and new-order.css
   (.rf-steps / .rf-step). Load both first. */

.rv-page {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.rv-body {
  flex-grow: 1;
  min-height: 0;
  padding: 22px 28px;
  display: flex;
  gap: 18px;
}
.rv-main {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

/* ---------------- header ---------------- */
.rv-head {
  min-width: 0;
  /* style.css sets header { font-weight:bold; margin; text-align:center }
     globally — this page's header is a left-aligned plain block. */
  text-align: left;
  font-weight: 400;
  margin: 0;
}
.rv-title {
  font-size: 30px;
  line-height: 1.1;
  color: #191714;
  margin: 5px 0 0;
  font-weight: 400;
}
.rv-subtitle {
  font-size: 13px;
  color: #6f6a60;
  margin-top: 4px;
  text-wrap: pretty;
}

/* ---------------- pre-confirm banner ---------------- */
.rv-banner {
  border: 1px solid #f0d9c9;
  background: #fdf6f1;
  border-radius: 10px;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 11px;
}
.rv-banner-bar {
  width: 3px;
  height: 30px;
  border-radius: 2px;
  background: #b0872f;
  flex-shrink: 0;
}
.rv-banner-text {
  flex-grow: 1;
  min-width: 0;
}
.rv-banner-title {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.rv-banner-list {
  font-size: 12.5px;
  color: #6f6a60;
  margin-top: 2px;
  text-wrap: pretty;
}

/* ---------------- fact sections ---------------- */
.rv-sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.rv-section,
.rv-products {
  background: #fff;
  border: 1px solid #e7e3da;
  border-radius: 12px;
  overflow: hidden;
}
.rv-products {
  flex-grow: 1;
  min-height: 0;
}
.rv-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  border-bottom: 1px solid #f0ece3;
}
.rv-section-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
}
.rv-fact {
  display: flex;
  gap: 12px;
  padding: 8px 15px;
  border-top: 1px solid #f7f4ee;
  font-size: 13px;
}
.rv-fact-k {
  width: 124px;
  flex-shrink: 0;
  color: #8b8477;
}
.rv-fact-v {
  color: #191714;
  font-weight: 500;
  text-wrap: pretty;
}
.rv-fact-v.is-danger {
  color: #a8483e;
  font-weight: 700;
}
.rv-fact-v.is-muted {
  color: #6f6a60;
}

/* ---------------- products: shared ---------------- */
.rv-viewtoggle {
  border-radius: 8px;
}
.rv-viewtoggle button {
  padding: 5px 11px;
  border-radius: 6px;
  font-size: 11.5px;
}
.rv-accent {
  width: 3px;
  height: 26px;
  border-radius: 2px;
  flex-shrink: 0;
}

/* ---------------- products: table view ---------------- */
.rv-thead {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 15px;
  background: #fbf9f5;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #8b8477;
}
.rv-trow {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-top: 1px solid #f7f4ee;
}
.rv-col-product {
  flex-grow: 1;
  min-width: 0;
}
.rv-col-dest {
  width: 120px;
  font-size: 12.5px;
  color: #4a453c;
}
.rv-col-qty {
  width: 52px;
  text-align: right;
  font-size: 13px;
  color: #4a453c;
}
.rv-col-unit {
  width: 76px;
  text-align: right;
  font-size: 13px;
  color: #6f6a60;
}
.rv-col-total {
  width: 82px;
  text-align: right;
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.rv-product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.rv-product-text {
  min-width: 0;
}
.rv-product-name {
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rv-product-meta {
  font-size: 11.5px;
  color: #a29b8d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------------- products: card view ---------------- */
.rv-cards {
  padding: 14px 15px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 11px;
}
.rv-card {
  border: 1px solid #e7e3da;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  background: #fff;
}
.rv-card-photo {
  width: 104px;
  flex-shrink: 0;
  background: #f0ece3;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #a29b8d;
  text-align: center;
}
.rv-card-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.rv-card-body {
  flex-grow: 1;
  min-width: 0;
  padding: 11px 13px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rv-card-top {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.rv-card-text {
  flex-grow: 1;
  min-width: 0;
}
.rv-card-name {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  line-height: 1.25;
  text-wrap: pretty;
}
.rv-card-meta {
  font-size: 11.5px;
  color: #a29b8d;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rv-card-qty {
  font-size: 12.5px;
  color: #4a453c;
  white-space: nowrap;
  flex-shrink: 0;
}
.rv-card-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.rv-chip {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 5px;
  white-space: nowrap;
}
.rv-chip.is-dest {
  color: var(--rf-brand-deep);
  background: var(--rf-brand-tint);
  border: 1px solid #ecdfc4;
}
.rv-chip.is-sash {
  color: #3e3931;
  background: #f6f4ef;
  border: 1px solid #e7e3da;
}
.rv-chip.is-note {
  color: #8e6a25;
  background: #f9f1de;
  border: 1px solid #eeddb8;
}
.rv-card-foot {
  margin-top: auto;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-top: 8px;
  border-top: 1px solid #f7f4ee;
}
.rv-card-unit {
  font-size: 11.5px;
  color: #8b8477;
  white-space: nowrap;
}
.rv-card-total {
  font-size: 14px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
}

/* ---------------- confirm rail ---------------- */
.rv-rail {
  width: 352px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rv-total-card {
  background: #191714;
  border-radius: 12px;
  padding: 18px 20px;
  color: #fff;
}
.rv-total-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
  margin-bottom: 12px;
}
.rv-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0;
  border-top: 1px solid #302b23;
  font-size: 12.5px;
}
.rv-total-row span:first-child {
  color: #b8b1a3;
}
.rv-total-row span:last-child {
  color: #fff;
  font-variant-numeric: tabular-nums;
}
.rv-total-row.is-total {
  font-size: 16px;
  font-weight: 600;
}
.rv-total-row.is-total span:first-child {
  color: #fff;
}
.rv-total-row.is-total span:last-child {
  color: var(--rf-brand-bright);
}
.rv-total-row.is-commission {
  border-top-style: dashed;
}
.rv-total-row.is-commission span {
  font-size: 12px;
}
.rv-total-row.is-net span {
  font-weight: 600;
}
.rv-payment {
  margin-top: 14px;
  padding: 11px 13px;
  background: #252017;
  border-radius: 9px;
}
.rv-payment-label {
  font-size: 11.5px;
  color: #a29b8d;
  margin-bottom: 3px;
}
.rv-payment-value {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}
.rv-effects {
  background: #fff;
  border: 1px solid #e7e3da;
  border-radius: 12px;
  padding: 16px 18px;
}
.rv-effects-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
  margin-bottom: 10px;
}
.rv-effect {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  font-size: 12.5px;
  color: #4a453c;
  line-height: 1.45;
  text-wrap: pretty;
  margin-bottom: 9px;
}
.rv-effect:last-child {
  margin-bottom: 0;
}
.rv-effect-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--rf-brand-lite);
  margin-top: 6px;
  flex-shrink: 0;
}
.rv-actions {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.rv-confirm {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  font-size: 14px;
}
.rv-confirm:disabled {
  opacity: 0.6;
  cursor: default;
}
.rv-back {
  width: 100%;
  height: 40px;
  border-radius: 10px;
}
.rv-serial-note {
  text-align: center;
  font-size: 11.5px;
  color: #a29b8d;
  padding-top: 2px;
}

/* ---------------- responsive: tablet ---------------- */
@media (max-width: 1200px) {
  .rv-body {
    flex-direction: column;
  }
  .rv-rail {
    width: 100%;
  }
  .rv-sections,
  .rv-cards {
    grid-template-columns: 1fr;
  }
}

/* the order is going into another business than the one on screen */
.rv-business {
  display: inline-block;
  margin-top: 8px;
  padding: 4px 10px;
  border-radius: 20px;
  background: #fbf5e7;
  border: 1px solid #e3c98f;
  font-size: 12.5px;
  color: #4a3b1c;
}
`, "",{"version":3,"sources":["webpack://./src/review-order.css"],"names":[],"mappings":"AAAA;;;6CAG6C;;AAE7C;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ;mEACiE;EACjE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["/* Review & confirm page.\n   Depends on dashboard-redesign.css (.rf-app, .rf-btn, .rf-link, .rf-serif,\n   .rf-num, .rf-spacer, .rf-segmented, .rf-label) and new-order.css\n   (.rf-steps / .rf-step). Load both first. */\n\n.rv-page {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.rv-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 22px 28px;\n  display: flex;\n  gap: 18px;\n}\n.rv-main {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n}\n\n/* ---------------- header ---------------- */\n.rv-head {\n  min-width: 0;\n  /* style.css sets header { font-weight:bold; margin; text-align:center }\n     globally — this page's header is a left-aligned plain block. */\n  text-align: left;\n  font-weight: 400;\n  margin: 0;\n}\n.rv-title {\n  font-size: 30px;\n  line-height: 1.1;\n  color: #191714;\n  margin: 5px 0 0;\n  font-weight: 400;\n}\n.rv-subtitle {\n  font-size: 13px;\n  color: #6f6a60;\n  margin-top: 4px;\n  text-wrap: pretty;\n}\n\n/* ---------------- pre-confirm banner ---------------- */\n.rv-banner {\n  border: 1px solid #f0d9c9;\n  background: #fdf6f1;\n  border-radius: 10px;\n  padding: 12px 15px;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n}\n.rv-banner-bar {\n  width: 3px;\n  height: 30px;\n  border-radius: 2px;\n  background: #b0872f;\n  flex-shrink: 0;\n}\n.rv-banner-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rv-banner-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.rv-banner-list {\n  font-size: 12.5px;\n  color: #6f6a60;\n  margin-top: 2px;\n  text-wrap: pretty;\n}\n\n/* ---------------- fact sections ---------------- */\n.rv-sections {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n.rv-section,\n.rv-products {\n  background: #fff;\n  border: 1px solid #e7e3da;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.rv-products {\n  flex-grow: 1;\n  min-height: 0;\n}\n.rv-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 15px;\n  border-bottom: 1px solid #f0ece3;\n}\n.rv-section-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n}\n.rv-fact {\n  display: flex;\n  gap: 12px;\n  padding: 8px 15px;\n  border-top: 1px solid #f7f4ee;\n  font-size: 13px;\n}\n.rv-fact-k {\n  width: 124px;\n  flex-shrink: 0;\n  color: #8b8477;\n}\n.rv-fact-v {\n  color: #191714;\n  font-weight: 500;\n  text-wrap: pretty;\n}\n.rv-fact-v.is-danger {\n  color: #a8483e;\n  font-weight: 700;\n}\n.rv-fact-v.is-muted {\n  color: #6f6a60;\n}\n\n/* ---------------- products: shared ---------------- */\n.rv-viewtoggle {\n  border-radius: 8px;\n}\n.rv-viewtoggle button {\n  padding: 5px 11px;\n  border-radius: 6px;\n  font-size: 11.5px;\n}\n.rv-accent {\n  width: 3px;\n  height: 26px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n/* ---------------- products: table view ---------------- */\n.rv-thead {\n  display: flex;\n  align-items: center;\n  height: 32px;\n  padding: 0 15px;\n  background: #fbf9f5;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #8b8477;\n}\n.rv-trow {\n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  border-top: 1px solid #f7f4ee;\n}\n.rv-col-product {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rv-col-dest {\n  width: 120px;\n  font-size: 12.5px;\n  color: #4a453c;\n}\n.rv-col-qty {\n  width: 52px;\n  text-align: right;\n  font-size: 13px;\n  color: #4a453c;\n}\n.rv-col-unit {\n  width: 76px;\n  text-align: right;\n  font-size: 13px;\n  color: #6f6a60;\n}\n.rv-col-total {\n  width: 82px;\n  text-align: right;\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.rv-product-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rv-product-text {\n  min-width: 0;\n}\n.rv-product-name {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rv-product-meta {\n  font-size: 11.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ---------------- products: card view ---------------- */\n.rv-cards {\n  padding: 14px 15px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 11px;\n}\n.rv-card {\n  border: 1px solid #e7e3da;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  background: #fff;\n}\n.rv-card-photo {\n  width: 104px;\n  flex-shrink: 0;\n  background: #f0ece3;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  color: #a29b8d;\n  text-align: center;\n}\n.rv-card-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.rv-card-body {\n  flex-grow: 1;\n  min-width: 0;\n  padding: 11px 13px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rv-card-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n.rv-card-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rv-card-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  line-height: 1.25;\n  text-wrap: pretty;\n}\n.rv-card-meta {\n  font-size: 11.5px;\n  color: #a29b8d;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rv-card-qty {\n  font-size: 12.5px;\n  color: #4a453c;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.rv-card-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.rv-chip {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 5px;\n  white-space: nowrap;\n}\n.rv-chip.is-dest {\n  color: var(--rf-brand-deep);\n  background: var(--rf-brand-tint);\n  border: 1px solid #ecdfc4;\n}\n.rv-chip.is-sash {\n  color: #3e3931;\n  background: #f6f4ef;\n  border: 1px solid #e7e3da;\n}\n.rv-chip.is-note {\n  color: #8e6a25;\n  background: #f9f1de;\n  border: 1px solid #eeddb8;\n}\n.rv-card-foot {\n  margin-top: auto;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  padding-top: 8px;\n  border-top: 1px solid #f7f4ee;\n}\n.rv-card-unit {\n  font-size: 11.5px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.rv-card-total {\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n}\n\n/* ---------------- confirm rail ---------------- */\n.rv-rail {\n  width: 352px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.rv-total-card {\n  background: #191714;\n  border-radius: 12px;\n  padding: 18px 20px;\n  color: #fff;\n}\n.rv-total-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  margin-bottom: 12px;\n}\n.rv-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 0;\n  border-top: 1px solid #302b23;\n  font-size: 12.5px;\n}\n.rv-total-row span:first-child {\n  color: #b8b1a3;\n}\n.rv-total-row span:last-child {\n  color: #fff;\n  font-variant-numeric: tabular-nums;\n}\n.rv-total-row.is-total {\n  font-size: 16px;\n  font-weight: 600;\n}\n.rv-total-row.is-total span:first-child {\n  color: #fff;\n}\n.rv-total-row.is-total span:last-child {\n  color: var(--rf-brand-bright);\n}\n.rv-total-row.is-commission {\n  border-top-style: dashed;\n}\n.rv-total-row.is-commission span {\n  font-size: 12px;\n}\n.rv-total-row.is-net span {\n  font-weight: 600;\n}\n.rv-payment {\n  margin-top: 14px;\n  padding: 11px 13px;\n  background: #252017;\n  border-radius: 9px;\n}\n.rv-payment-label {\n  font-size: 11.5px;\n  color: #a29b8d;\n  margin-bottom: 3px;\n}\n.rv-payment-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n.rv-effects {\n  background: #fff;\n  border: 1px solid #e7e3da;\n  border-radius: 12px;\n  padding: 16px 18px;\n}\n.rv-effects-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n  margin-bottom: 10px;\n}\n.rv-effect {\n  display: flex;\n  gap: 9px;\n  align-items: flex-start;\n  font-size: 12.5px;\n  color: #4a453c;\n  line-height: 1.45;\n  text-wrap: pretty;\n  margin-bottom: 9px;\n}\n.rv-effect:last-child {\n  margin-bottom: 0;\n}\n.rv-effect-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--rf-brand-lite);\n  margin-top: 6px;\n  flex-shrink: 0;\n}\n.rv-actions {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n.rv-confirm {\n  width: 100%;\n  height: 46px;\n  border-radius: 10px;\n  font-size: 14px;\n}\n.rv-confirm:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n.rv-back {\n  width: 100%;\n  height: 40px;\n  border-radius: 10px;\n}\n.rv-serial-note {\n  text-align: center;\n  font-size: 11.5px;\n  color: #a29b8d;\n  padding-top: 2px;\n}\n\n/* ---------------- responsive: tablet ---------------- */\n@media (max-width: 1200px) {\n  .rv-body {\n    flex-direction: column;\n  }\n  .rv-rail {\n    width: 100%;\n  }\n  .rv-sections,\n  .rv-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* the order is going into another business than the one on screen */\n.rv-business {\n  display: inline-block;\n  margin-top: 8px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  background: #fbf5e7;\n  border: 1px solid #e3c98f;\n  font-size: 12.5px;\n  color: #4a3b1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
